import { graphql } from 'react-relay';

import useMutation from '@zego/mutations/useMutation';

const mutation = graphql`
  mutation useScooterEstimateResultMutation(
    $input: ScooterPriceEstimate2Input!
  ) {
    result: getScooterPriceEstimate2(input: $input) {
      estimateResult {
        state
        ...estimateLead @relay(mask: false)
        ...ScooterQuickEstimatesGbContainer_estimateResult
      }
    }
  }
`;

export default function useScooterEstimateResult() {
  return useMutation(mutation);
}
